import { fr, enCA } from 'date-fns/locale';

const supportedLocales = {
  fr,
  'fr-CA': fr,
  fr_CA: fr,
  en: enCA,
  enCA,
  'en-CA': enCA,
  en_CA: enCA
};

const dateFnsLocale = locale => supportedLocales[locale];

export default dateFnsLocale;
